// extracted by mini-css-extract-plugin
module.exports = {"modal_title":"PrintTagsModal_modal_title__3yEi7","modal_body":"PrintTagsModal_modal_body__wEp2q"};